"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeI18Next = initializeI18Next;
const i18next_1 = __importDefault(require("i18next"));
const index_1 = require("../index");
const languageDetector_1 = require("./languageDetector");
/**
 * Detect available namespaces by traversing the en translation files
 * @param projectPath
 */
function detectNamespaces(projectPath) {
    return ['ServerErrors'];
    // return fs
    //   .readdirSync(path.join(projectPath, '/i18n/en'))
    //   .filter((file: string) => path.extname(file) === '.yaml')
    //   .map((filename: string) => filename.replace('.yaml', ''));
}
function initializeI18Next({ fallbackLanguage = 'en', supportedLanguages = [], projectPath, }) {
    const debug = index_1.Utilities.ProcessEnv.isEnabled('DEBUG_I18NEXT');
    const instance = i18next_1.default.createInstance({
        // https://www.i18next.com/overview/configuration-options#initimmediate
        // TL;DR: initImmediate needs to be false for sync translation loading
        initImmediate: false,
        debug,
        fallbackLng: fallbackLanguage,
        returnEmptyString: true,
        supportedLngs: ['en', ...supportedLanguages],
        ns: detectNamespaces(projectPath),
        interpolation: {
            escapeValue: false,
        },
        // todo support backend for i18nnext on server-side react apps.
        // backend: {
        //   loadPath: path.join(projectPath, '/locales/{{lng}}/{{ns}}.yaml'),
        //   addPath: debug
        //     ? path.join(projectPath, '/locales/{{lng}}/{{ns}}.missing.yaml')
        //     : undefined,
        // },
    });
    /**
     * Note: the Promise from init is intentional not awaited - because
     * we force initImmediate = false, which leads to synchronous loading of
     * all translation files, although the Typescript interface does not reflect
     * that
     */
    // noinspection JSIgnoredPromiseFromCall
    // instance.use(FilesystemBackend).init((err: Error) => {
    //   if (err) {
    //     console.error('i18next initialization error:', err);
    //     throw err;
    //   }
    // });
    const languageDetector = (req) => {
        return (0, languageDetector_1.detectLanguage)({
            supportedLanguages,
            fallbackLanguage,
            acceptLanguageHeader: req.headers?.['accept-language'],
        });
    };
    const getTranslate = (req, namespace) => {
        return instance.getFixedT(languageDetector(req), namespace);
    };
    return {
        i18next: instance,
        languageDetector,
        getTranslate,
    };
}
